export default __webpack_public_path__ + "static/media/bd.b90eb817.svg";